// extracted by mini-css-extract-plugin
export default {"panel-btn":"EditorCanvas_panel-btn__7USAS","full-page-loader":"EditorCanvas_full-page-loader__mKdYp","download-ct":"EditorCanvas_download-ct__I-aZG"};